export default __webpack_public_path__ + "static/media/signin-background.aa691108.png";